import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import Description from '@mui/icons-material/Description';

type InternalNotesIconProps = {
    isInternalOrderData: boolean;
};
const InternalNotesIcon: FC<InternalNotesIconProps> = ({ isInternalOrderData }: InternalNotesIconProps) => {
    const { t: translate } = useTranslation(['orders']);

    return (
        <Fragment>
            {isInternalOrderData ? (
                <Tooltip title={<span>{translate('orders:HAS_INTERNAL_NOTES')}</span>}>
                    <Description color="secondary" />
                </Tooltip>
            ) : (
                <Tooltip title={<span>{translate('orders:NO_INTERNAL_NOTES')}</span>}>
                    <DescriptionOutlinedIcon sx={{ color: '#f2f2f2' }} />
                </Tooltip>
            )}
        </Fragment>
    );
};

export default InternalNotesIcon;
